import React from 'react'
import PropTypes from 'prop-types'
import capitalize from 'lodash/capitalize'

import { useFormContext } from 'react-hook-form'
import { Box, Typography, InputAdornment } from '@mui/material'

import { HHFormNumberField } from 'components/form-fields/v5'
import { WEIGHT_DECIMAL_SCALE } from 'components/pricing/DisposalFeesV2/create-edit-disposal-fee-dialog/settings'
import { FIELD_WIDTH } from 'components/work-order/disposal-ticket-dialog/disposal-fee/fields/settings'

import T from 'T'

const OverageThresholdField = ({ index, unit = '' }) => {
  const { control } = useFormContext()

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography>{`${capitalize(T.OVERAGE_THRESHOLD)}:`}</Typography>
      <HHFormNumberField
        sx={{ width: FIELD_WIDTH }}
        size="small"
        control={control}
        name={`materials.${index}.overageWeight`}
        fullWidth
        placeholder=""
        decimalScale={WEIGHT_DECIMAL_SCALE}
        InputProps={{ endAdornment: <InputAdornment position="end">{`${unit}s`}</InputAdornment> }}
      />
    </Box>
  )
}

OverageThresholdField.propTypes = {
  index: PropTypes.number,
  unit: PropTypes.string,
}

export default OverageThresholdField
